import { action, computed, observable } from 'mobx'
import { mdiEyeOff } from '@mdi/js'

export default class CategoryModel {
  rootStore = null

  @observable accessor id = 0
  @observable accessor name = ''
  @observable accessor description = ''
  @observable accessor published = true

  constructor(rootStore, categoryData) {
    this.rootStore = rootStore
    this.update(categoryData)
  }

  get api() {
    return this.rootStore.apiStore
  }

  get auth() {
    return this.rootStore.authStore
  }

  @computed
  get comboboxItem() {
    return {
      iconPath: !this.published ? mdiEyeOff : null,
      label: this.name,
      value: this.id.toString(),
    }
  }

  @action
  update = categoryData => {
    this.id = categoryData.categoryId ?? categoryData.id ?? this.id
    this.name = categoryData.categoryName ?? categoryData.name ?? this.name
    this.description = categoryData.description ?? this.description
    this.published = Boolean(categoryData.published ?? this.published)

    // NOT USED: address, createdAt, deleted, price, promotion
  }

  updateViaForm = async values => {
    if (!this.auth.user.isAuthUser) return false

    const response = await this.api.updateCategory({
      ...values,
      id: this.id,
    })
    if (response?.data?.status !== 'OK') return false

    this.update(values)

    return true
  }
}
